import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { provideComponent, useDataItem } from "scrivito"
import { KpiCard } from "shared/ui/kpi-card/KpiCard"

import { SignInKpiWidget } from "./SignInKpiWidgetClass"

provideComponent(SignInKpiWidget, () => {
  const { t } = useTranslation()
  const kpiData = useDataItem("UserKPIs")

  const signInCount = useMemo(() => {
    return {
      last7Days: kpiData?.get("externalLoginLast7Days") as number,
      last30Days: kpiData?.get("externalLoginLast30Days") as number
    }
  }, [kpiData])

  return (
    <KpiCard.Root>
      <KpiCard.Title title={t("KPIs.SignIn")} />
      <KpiCard.DataList
        data={[
          { label: t("KPIs.Last7Days"), value: signInCount.last7Days },
          { label: t("KPIs.Last30Days"), value: signInCount.last30Days }
        ]}
      />
    </KpiCard.Root>
  )
})
